var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClouds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 31,
    viewBox: "0 0 41 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0034 6.01781C28.3404 6.01781 31.9353 10.2124 32.4582 15.2781L32.6181 15.2781C36.6963 15.2781 40.0023 18.5755 40.0023 22.6431C40.0023 26.7107 36.6963 30.0082 32.6181 30.0082H11.3886C7.31049 30.0082 4.00449 26.7107 4.00449 22.6431C4.00449 18.5755 7.31049 15.2781 11.3887 15.2781L11.5486 15.2781C12.0745 10.1791 15.6663 6.01781 22.0034 6.01781ZM16 0C19.2338 0 22.099 1.63065 23.8007 4.12461C23.2185 4.05361 22.6179 4.01781 22 4.01781C15.9223 4.01781 11.5239 7.45573 10.0398 12.6325L9.96041 12.9219L9.84472 13.3974L9.43152 13.4743C6.21532 14.1482 3.5997 16.475 2.52612 19.5337C0.989077 18.3342 0 16.4621 0 14.359C0 10.7337 2.93885 7.79487 6.56414 7.79487L6.70627 7.79488C7.48465 3.35222 11.3634 0 16 0Z",
    fill: "#9BCAEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.39301a68c38fc850ad6652e5aeab6e18.svg";
export { ForwardRef as ReactComponent };